const allowClick = () => {
	return document.body.classList.contains( 'allow-toggle-click' );
};

export default allowClick;
